var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"WorkBench"}},[_c('h1',[_vm._v("Work Bench for "+_vm._s(_vm.component_name))]),_c('hr'),_c(_vm.component_name,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }